import React from 'react';

const Programs = () => {
  const programs = [
    {
      id: 1,
      icon: '🌍',
      title: 'Languages',
      description: 'Master Arabic, French, English, and Italian with immersive learning experiences designed for all ages and skill levels.',
      link: '#languages'
    },
    {
      id: 2,
      icon: '🤖',
      title: 'Robotics',
      description: 'Build and program intelligent robots using Arduino, ESP32, LEGO EV3, and Spark technologies with hands-on projects.',
      link: '#robotics'
    },
    {
      id: 3,
      icon: '💻',
      title: 'Programming',
      description: 'Learn Python, Web Development, Scratch, and more through project-based learning suitable for beginners to advanced learners.',
      link: '#programming'
    }
  ];

  return (
    <section className="section alt" id="programs">
      <div className="container">
        <h2 className="section-title fade-in">Our Three Pillars of Excellence</h2>
        <p className="section-subtitle fade-in">
          Empowering learners of all ages with essential 21st-century skills through innovative, inclusive education
        </p>
        
        <div className="programs-grid">
          {programs.map((program, index) => (
            <div 
              key={program.id}
              className="flip-card scale-in" 
              tabIndex="0" 
              role="button" 
              aria-label={`${program.title} program details`}
            >
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="card-icon" aria-hidden="true">{program.icon}</div>
                  <h3 className="card-title">{program.title}</h3>
                </div>
                <div className="flip-card-back">
                  <div className="card-icon" aria-hidden="true">{program.icon}</div>
                  <h3 className="card-title">{program.title}</h3>
                  <p className="card-description">{program.description}</p>
                  <a href={program.link} className="card-btn" role="button">
                    Learn More <i className="fas fa-arrow-right" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Programs;